export enum Papel {
    UsuarioComum = 'UsuarioComum',
    Nivel1 = 'Nivel1',
    Nivel2 = 'Nivel2',
    Administrador = 'Administrador',
}


export interface Papeis {
    [Papel.UsuarioComum]: boolean
    [Papel.Nivel1]: boolean
    [Papel.Nivel2]: boolean
    [Papel.Administrador]: boolean
}

// Ordem dos papéis deve estar do MAIOR perfil para o menor
export const listaPapeis = [
    Papel.Administrador,
    Papel.Nivel2,
    Papel.Nivel1,
    Papel.UsuarioComum,
]


export const PAPEIS_MEMBROS_ACUMULATIVO: {[key: string]: Papel[]} = {
    [Papel.UsuarioComum]: [Papel.UsuarioComum],
    [Papel.Nivel1]: [Papel.UsuarioComum, Papel.Nivel1],
    [Papel.Nivel2]: [Papel.UsuarioComum, Papel.Nivel1, Papel.Nivel2],
    [Papel.Administrador]: [Papel.UsuarioComum, Papel.Nivel1, Papel.Nivel2, Papel.Administrador]
}